import { rest } from 'msw';

import { getApiBaseUrl } from 'src/utils/configStore';

import { UpdateProductPayload, UpdateProductsPayload } from '../types';

import * as productsApi from '../products.api';

import { MOCK_RES } from './products.api.mock.responses';

const baseURL = getApiBaseUrl();
const delayDuration = 1500;

const mapResponseFromRequest = (products: UpdateProductPayload[]) => {
    const baseResponse = JSON.parse(JSON.stringify(MOCK_RES.GET_products));

    for (const product of products) {
        for (const stdLiability of baseResponse?.insurances
            ?.standardLiabilities || []) {
            if (stdLiability.id.productId === product.id.productId) {
                stdLiability.quantity = 1;
            }
        }
        for (const rdcLiability of baseResponse?.insurances
            ?.reducedLiabilities || []) {
            if (rdcLiability.id.productId === product.id.productId) {
                rdcLiability.quantity = 1;
            }
        }
        for (const optLiability of baseResponse?.insurances
            ?.optionalLiabilityUpgrades || []) {
            if (optLiability.id.productId === product.id.productId) {
                optLiability.quantity = 1;
            }
        }
    }

    return baseResponse;
};

const vehicleProtectionsApiMocks = [
    rest.post<UpdateProductsPayload>(
        `${baseURL}${productsApi.productsApiRoute}`,
        async (req, res, ctx) => {
            const { products } = await req.json();

            return res(
                ctx.delay(delayDuration),
                ctx.status(200),
                ctx.json(mapResponseFromRequest(products)),
            );
        },
    ),
    rest.get(
        `${baseURL}${productsApi.productsApiRoute}`,
        async (req, res, ctx) => {
            return res(
                ctx.delay(delayDuration),
                ctx.status(200),
                ctx.json(MOCK_RES.GET_products),
            );
        },
    ),
];

export default vehicleProtectionsApiMocks;
